import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux'; 
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { SyncLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';
import { AiOutlineSetting, AiOutlineUser,AiOutlineLogout, AiOutlineLayout, AiOutlineEdit, AiOutlinePlus, AiOutlineSafety} from 'react-icons/ai';
import { BiDotsHorizontalRounded } from 'react-icons/bi';
import MenuIcon from '@mui/icons-material/Menu';
import { userService } from '../services/user.service';
import BoardModal from '../cmps/modal/modal-board-election';
import '../assets/styles/board-election.css';
import completedTaskIcon from '../assets/img/logoF.png';
import logo1 from '../assets/img/logo1.png';
import{ROLES}from '../cmps/../services/user.service'
import  UserManagement  from '../cmps/board/board-administration';
import { logout,clearUsers } from "../store/user.actions"
import { FaUser } from "react-icons/fa";
import { CargarInfoModulos } from "../store/grupo.actions";
import { loadBoards,loadRegionBoards } from "../store/board.actions";
import { CargarUsers} from "../store/user.actions";
import PasswordChangeModal from '../cmps/modal/modal-update-password';
import { grupoService } from '../services/grupo.service';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material'; // Importar componentes de Material-UI



function BoardsPage() {
  // const [boards, setBoards] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [user, setUser] = useState(userService.getLoggedinUser().data.data);
  const boards = useSelector( (storeState) => storeState.boardModule.boards );
  const [menuVisible, setMenuVisible] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [boardToEdit, setBoardToEdit] = useState(null);
  const navigate = useNavigate();
  const [isMenuOpenheader, setIsMenuOpenheader] = useState(false);

  const firstName = user?.nombre?.split(' ')[0]?.toUpperCase() || '';
  const lastName = user?.apellido?.split(' ')[0]?.toUpperCase() || '';

  const [userManagementOpen, setUserManagementOpen] = useState(false);
  const DataInfo = useSelector(storeState => storeState.infoModulo.infoM); 
  const regionOptions = DataInfo?.regionOptions || []; // Extraer regionOptions de DataInfo

  const isEditable = user.rol === ROLES.ADMIN;
  const specialPermisEditable = user.rol === ROLES.ADMIN && user.special_permission === "true";
  const [isPasswordChangeOpen, setIsPasswordChangeOpen] = useState(false);
  // const firstBoardId = boards[0]?.fk_region_id || null;
 

  async function loadBoardss() {
    try {
    await loadBoards(user.id_usuario, user.fk_region_id);
     
   
     
    } catch (error) {
      console.error('Error al cargar los tableros:', error);
    }
    setIsLoading(false);
  }

  //Funcion para actualizar la region de los tableros
  async function loadBoardsRegion(idRegion) {
    try {
      console.log("Estoy entrando aqui loguin");
    await loadRegionBoards(idRegion);
    await CargarUsers(idRegion);

     
    } catch (error) {
      console.error('Error al cargar los tableros:', error);
    }
    setIsLoading(false);
  }
  

  async function CargarModulos() {
  
    try {
    
      if (DataInfo.length ===0||DataInfo === undefined) {
        await CargarInfoModulos(user.fk_region_id);
      } else {
        
      }
    } catch (error) {
      console.error('Error al cargar los tableros:', error);
    }
  }


  useEffect(() => {
    loadBoardss();
    CargarModulos();
    
  }, []);

  function navigateToBoard(id_tablero) {
    setIsLoading(true);
    navigate(`/board/${id_tablero}`);
  }

  function handlePasswordChangeSave(InfoUser) {

  grupoService.ChangePasswordUser(InfoUser);

    setIsPasswordChangeOpen(false);  // Cerrar el modal después de guardar
}



  function toggleSidebar() {
    setIsSidebarOpen(!isSidebarOpen);
  }

  function toggleMenu(boardId, event) {
    event.stopPropagation();
    setMenuVisible(menuVisible === boardId ? null : boardId);
  }

  function openModal(board) {
    setBoardToEdit(board);
    setModalOpen(true);
  }

  function closeModal() {
    setBoardToEdit(null);
    setModalOpen(false);
  }

  async function handleSave() {
    await loadBoardss(); // Reload the boards after saving
    closeModal();
  }

  function onLogout() {
    // Llama a la función de logout
    logout();
    clearUsers();

    // Redirige a la página de inicio
    navigate('/');
  }


//para abrir el menu del usuario en el header
  const usermenuheader = () => {
    setIsMenuOpenheader(!isMenuOpenheader);
  };

  // Función para manejar el cambio de región
  const handleSelectChange = (selectedValue) => {
    loadBoardsRegion(selectedValue);
    
  };
  


  return (
    <>
      <header className={`header ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
        <div className="header-content">
          <button className="toggle-button" onClick={toggleSidebar}>
            <MenuIcon />
          </button>
          <div className="header-logo">
            {/* <img src={logo1} alt="Logo" /> */}
          </div>
          <div className="header-icons">
            <button className="icon-buttonheader">
              <img src="https://administracion.cderl.com//public/media/mainimg.png" alt="Logo" style={{ width: '90px', height: 'auto' }} className="Menu-logo" />
            </button>
            <button className="icon-buttonheader" onClick={usermenuheader}>
        <FaUser /> 
        <h5>Mi cuenta</h5>
      </button>

      {isMenuOpenheader && (
        <div className="dropdown-menuheader">
          {/* <div className="menu-itemheader">
            <AiOutlineUser className="menu-iconheader" />
            <span>Perfil</span>
          </div> */}
                {/* Opción para cambiar la contraseña */}
            <div className="menu-itemheader" onClick={() => setIsPasswordChangeOpen(true)}>
            <AiOutlineSafety className="menu-iconheader" />
            <span>Contraseña</span>
          </div>
          <div className="menu-itemheader" onClick={onLogout}>
            <AiOutlineLogout className="menu-iconheader" />
            <span>Cerrar sesión</span>
          </div>

     

        </div>
      )}
          </div>
        </div>
      </header>

        
      <div className="container">
        <div className={`Menu ${isSidebarOpen ? 'open' : 'closed'}`}>
            <img src={logo1} alt="Logo" className="Menu-logo" />
          {!isSidebarOpen &&
          <div className="divider"></div>}

          {!isSidebarOpen && ( 
            <div className="user-info">
              {user.imgurl && <img src={user.imgurl} alt="User" className="user-avatar" />}
            </div>
          )}

          {isSidebarOpen && (
            <>
              <h2 style={{ fontFamily: "Figtree", marginTop: 3}} className="Menu-title">CDE MIPYME RL</h2>
              <div className="divider"></div>
              <div className="user-info">
                {user.imgurl && <img src={user.imgurl} alt="User" className="user-avatar" />}
                <span className="user-name">{`${firstName} ${lastName}`}</span>
              </div>
              <div className="divider"></div>
            </>
          )}
          <div className={`config-options ${!isSidebarOpen ? 'centered' : ''}`}>{!isSidebarOpen &&
          <div className="divider"></div>
        }
           {isEditable && (
        <>
          <button className="config-option" onClick={() => openModal(null)}>
            <AiOutlineLayout style={{ fontSize: '24px' }} />
            {isSidebarOpen && 'Nuevo Tablero'}
          </button>
          <button className="config-option" onClick={() => setUserManagementOpen(true)}>
              <AiOutlineSetting style={{ fontSize: '24px' }}  />
              {isSidebarOpen && 'Administración'}
            </button>

        </>
      )}

          </div>
        </div>


        <div className="boards-page">


{specialPermisEditable && (
        <FormControl
          variant="outlined"
          sx={{
            minWidth: 170,
            marginTop: -1,
            transition: 'min-width 0.3s ease',
            alignSelf: 'flex-end',
            marginLeft: 'auto',
            borderColor: '#1976d2',
            '& .MuiInputLabel-root': {
              color: '#1976d2',
            },
            '& .MuiOutlinedInput-root': {
              '&:hover fieldset': {
                borderColor: '#1976d2',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#1976d2',
              },
            },
          }}
        >
          <InputLabel id="region-select-label">Región</InputLabel>
          <Select
            labelId="region-select-label"
            id="region-select"
            value={user.fk_region_id} // Asegurarse de que el valor está controlado
            onChange={(event) => handleSelectChange(event.target.value)}
            label="Región"
            sx={{
              borderRadius: '12px',
              backgroundColor: '#f0f0f0', // Fondo sutil
              '& .MuiSelect-select': {
                padding: '10px',
                display: 'flex',
                alignItems: 'center',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#1976d2',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#1976d2',
              },
              '& .MuiSvgIcon-root': {
                color: '#1976d2', // Cambiar color del icono
              },
            }}
          >
            {regionOptions.map((region) => (
              // Usar el id_regioncde como valor
              <MenuItem key={region.id_regioncde} value={region.id_regioncde}>
                {region.nombre_region} {/* Mostrar nombre de la región */}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )}



          <h1 style={{ fontFamily: "Figtree"}} className="page-title">Tableros</h1>
          <hr />
          {isLoading && (
            <div style={{ marginTop: '10rem', display: 'flex', justifyContent: 'center' }}>
              <SyncLoader color="#01a5d2" size={20} />
            </div>
          )}
          {!isLoading && (
            <div className="board-selector">
              {boards.map((board) => (
                <Card className="board-card" key={board.id_tablero} onClick={() => navigateToBoard(board.id_tablero)}>
                  <div className="board-media" style={{ backgroundColor: board.color, width: '100%', height: '100px', cursor: 'pointer', display: 'grid', placeItems: 'center' }}>
                    <img src={completedTaskIcon} alt="Completed Task" style={{ width: '8rem' }} />
                  </div>
                  <CardContent className="board-content">
                    <Typography variant="h6" component="div" className="board-title">
                      <AiOutlineLayout style={{ marginRight: '10px' }} />
                      <span>{board.nombre_tablero}</span>
                      {isEditable && (
                        <BiDotsHorizontalRounded
                          className="icontablero"
                          onClick={(event) => toggleMenu(board.id_tablero, event)}
                          style={{ marginLeft: 'auto', cursor: 'pointer' }}
                        />
                      )}
                    </Typography>
                    <div className="board-options" onClick={(e) => toggleMenu(board.id_tablero, e)}>
                      <Typography variant="body2" color="text.secondary" className="board-description">
                      {board.descripcion || "Descripción del Tablero..."}
                    </Typography>

                      {menuVisible === board.id_tablero && (
                       
                        <div className="menuTablero">
                           {isEditable && (
                          <button className="menuTablero-item" onClick={() => openModal(board)}>Editar <AiOutlineEdit/> </button>
                        )}
                          
                       
                        </div>
                      )}

                    </div>
                  </CardContent>
                </Card>
              ))}
            </div>
          )}
        </div>
      </div>
      
      <BoardModal open={modalOpen} onClose={closeModal} boardToEdit={boardToEdit} onSave={handleSave} />
      <UserManagement open={userManagementOpen} onClose={() => setUserManagementOpen(false)} />
      <PasswordChangeModal
      open={isPasswordChangeOpen}
      onClose={() => setIsPasswordChangeOpen(false)}
      onSave={handlePasswordChangeSave}
      />
    </>
  );
}

export default BoardsPage;
